// Type definitions for Race Participants

/**
 * @typedef {Object} Bird
 * @property {string} id - Bird identifier
 * @property {string} bandNumber - Bird band number
 * @property {string} color - Bird color
 * @property {string} sex - Bird sex
 * @property {string} status - Bird status (active, reserved, rotation)
 */

/**
 * @typedef {Object} BreederInfo
 * @property {string} handlerName - Assigned handler name
 * @property {string} handlerSection - Handler's section
 * @property {Bird[]} assignedBirds - List of birds assigned to handler
 */

/**
 * @typedef {Object} HandlerInfo
 * @property {string} section - Section (NORTH, CENTRAL, SOUTH)
 * @property {number} totalBirds - Total number of birds in race
 * @property {number} reserved - Number of reserved slots
 * @property {number} openSlots - Number of open slots
 * @property {Object[]} breeders - List of breeders assigned to this handler
 * @property {string} breeders[].breederName - Breeder name
 * @property {string} breeders[].loftName - Breeder loft name
 * @property {Bird[]} breeders[].birds - Birds from this breeder
 */

/**
 * @typedef {Object} Participant
 * @property {string} id - Unique identifier
 * @property {string} lastUpdatedDate - ISO date string
 * @property {string} fullName - Participant full name
 * @property {string} loftName - Loft name
 * @property {string} emailAddress - Email address
 * @property {string} mobile - Mobile phone number
 * @property {string} role - Role (breeder, handler, admin, both)
 * @property {string} preferredNotificationMethod - Preferred notification (email, text, inapp)
 * @property {HandlerInfo} [handlerInfo] - Handler specific information
 * @property {BreederInfo} [breederInfo] - Breeder specific information
 */

export const ParticipantRoles = {
  BREEDER: 'breeder',
  HANDLER: 'handler',
  ADMIN: 'admin',
  BOTH: 'both'
};

export const NotificationMethods = {
  EMAIL: 'email',
  TEXT: 'text',
  INAPP: 'inapp'
};

export const Sections = {
  NORTH: 'NORTH',
  CENTRAL: 'CENTRAL',
  SOUTH: 'SOUTH'
};

export const BirdStatus = {
  ACTIVE: 'active',
  RESERVED: 'reserved',
  ROTATION: 'rotation'
};
